window.init_tankopedia_dropdown = function(){
    var MENU_SELECTOR = '.js-filters-menu',
        NAMESPACE = '.category_menu',
        $menu = $(MENU_SELECTOR),
        $body = $(document.body),
        menuOpenClass = $menu.data('openClass'),
        anchorClass = 'menu-filters_link';

    function closeMenuOnBodyClick(e) {
        if ($(e.target).parents().index($menu) === -1) {
            closeCategoryMenu();
        }
    }

    function closeCategoryMenu() {
        $menu.removeClass(menuOpenClass);
        $body.off(NAMESPACE, closeMenuOnBodyClick);
    }

    function openCategoryMenu() {
        $menu.addClass(menuOpenClass);
        $body.on('click' + NAMESPACE + ' touchstart' + NAMESPACE, closeMenuOnBodyClick);
    }

    
    $menu.on('click' + NAMESPACE, function (e) {
        var $target = $(e.target);

        if ($menu.hasClass(menuOpenClass)) {
            if ($target.hasClass(anchorClass) && !$target.attr('href')) {
                return;
            } else {
                closeCategoryMenu();
            }

        } else {
            openCategoryMenu();
        }
    });

};
